import "./Table.css"
var DeveloperPortalCredentialsRow = function(props){
    return <div className="c_developerportal_companies_searchresults row">
        <div className="col-md-6" title={"ID: " + props.serialid}>{props.emailid}</div>
        <div className="col-md-3">{props.superadmin === 0? <button className="c_developerportal_buttononwhite" onClick={props.superadminhandler.bind(null, 1, props.serialid)}>Promote</button>:<button className="c_developerportal_buttononwhite" onClick={props.superadminhandler.bind(null, 0, props.serialid)}>Demote</button>}</div>
        <div className="col-md-3"><button className="c_developerportal_buttononwhite" onClick={props.deletehandler.bind(this, props.serialid)}>Delete</button></div>
    </div>
}
export default DeveloperPortalCredentialsRow